export default __webpack_public_path__ + "static/media/AuctionSnap.f1c1eaf1.png";